import Vue from 'vue'
import VueHcaptcha from '@hcaptcha/vue-hcaptcha'

Vue.component('vue-hcaptcha', VueHcaptcha)
